import React, { Component } from 'react';
import styles from './UsageReport.module.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { gridOptions } from './lib/report';
import { fetchJobs } from '../../modules/jobs';
import moment from 'moment';

class UsageReport extends Component {
  state = {
    downloading: false,
    error: null,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  async componentDidMount() {
    const { fetchJobs } = this.props;
    const gridDiv = document.getElementById('myGrid');
    const grid = new window.agGrid.Grid(gridDiv, gridOptions);
    const api = grid.gridOptions.api;
    const jobs = await fetchJobs({ limit: 1000, type: 'all' });
    for (let i in jobs) {
      jobs[i].date = moment(jobs[i].createdAt).format('MM/DD/YYYY');
      jobs[i].CPUTime = jobs[i].finishedAt
        ? 32 *
          Number(
            moment
              .duration(moment(jobs[i].finishedAt).diff(jobs[i].createdAt))
              .asHours()
              .toFixed(2)
          )
        : 0;
      jobs[i].name = jobs[i].name || 'Model Preview';
    }
    api.setRowData(jobs);
  }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.header}>Render Report</div>
        <div id="myGrid" style={{ height: 1000 }} className="ag-theme-balham" />
      </div>
    );
  }
}

export default connect(
  state => ({}),
  { fetchJobs }
)(UsageReport);



// WEBPACK FOOTER //
// ./src/containers/UsageReport/index.js